export default __webpack_public_path__ + "static/media/3f5d6e55a06a0838c76bc7c76a896a63.svg";